(function () {
  "use strict";
  window.PesadoCompatibilityAssignmentSetLoader =
    "PESADO_ASSIGNMENT_SETS_LOADER_V1";
  const E = "187483062579",
    p = document.currentScript,
    I = p && p.src ? p.src.replace(/[^/?#]+(?:\?[^#]*)?$/, "") : "";
  let b,
    w = !1;
  window.PesadoCompatibilityReady = new Promise((t) => {
    b = t;
  });
  function v(t) {
    w || ((w = !0), b(t));
  }
  function V(t) {
    const a = window.atob(String(t || "").replace(/\s/g, "")),
      o = Uint8Array.from(a, (n) => n.charCodeAt(0));
    return JSON.parse(new TextDecoder("utf-8").decode(o));
  }
  function O() {
    if (window.PesadoCompatibilityManagerConfig) return;
    const t = document.getElementById("pesado-compatibility-manager-config");
    if (t)
      try {
        window.PesadoCompatibilityManagerConfig = V(t.textContent);
      } catch (a) {
        console.error("[Pesado Compatibility] Invalid Manager publication.", a);
      }
  }
  let managerManifestRequest;
  async function loadManagerManifest() {
    O();
    if (window.PesadoCompatibilityManagerConfig) return !0;
    if (managerManifestRequest) return managerManifestRequest;
    const source = document.getElementById(
      "pesado-compatibility-manager-manifest",
    );
    if (!source) return !1;
    managerManifestRequest = (async () => {
      const controller = new AbortController(),
        timeout = window.setTimeout(() => controller.abort(), 8000);
      try {
        const manifest = JSON.parse(source.textContent || "{}"),
          targetThemeId = String(
            manifest.targetTheme && manifest.targetTheme.id,
          );
        if (
          targetThemeId !== E ||
          manifest.channel !== "live" ||
          !/^https:\/\//i.test(String(manifest.url || ""))
        )
          throw new Error("Manager manifest does not target this live theme.");
        const response = await window.fetch(manifest.url, {
          credentials: "omit",
          signal: controller.signal,
        });
        if (!response.ok)
          throw new Error(
            `Manager publication request failed (${response.status}).`,
          );
        const publication = await response.json();
        if (
          String(publication.targetTheme && publication.targetTheme.id) !== E ||
          publication.channel !== manifest.channel ||
          Number(publication.version) !== Number(manifest.version) ||
          publication.checksum !== manifest.checksum ||
          !publication.configuration
        )
          throw new Error("Manager publication does not match its manifest.");
        window.PesadoCompatibilityManagerConfig = publication;
        return !0;
      } catch (error) {
        console.error(
          "[Pesado Compatibility] Unable to load the live Manager publication.",
          error,
        );
        return !1;
      } finally {
        window.clearTimeout(timeout);
      }
    })();
    return managerManifestRequest;
  }
  function f(t) {
    if (!t) return "";
    const a = t.cdnUrl || t.previewUrl || t.value || "";
    if (/^https?:\/\//i.test(a) || /^\/\//.test(a)) return a;
    if (t.kind !== "theme_asset" || !I || !t.value) return "";
    const o = String(t.value).split(/[\\/]/).pop();
    return o ? I + encodeURIComponent(o) : "";
  }
  function g(t, a, o, n) {
    const l = Number(t);
    return Number.isFinite(l) ? Math.min(o, Math.max(a, Math.round(l))) : n;
  }
  function P(t) {
    return {
      scale: g(t && t.scale, 70, 180, 100),
      offsetX: g(t && t.offsetX, -30, 30, 0),
      offsetY: g(t && t.offsetY, -30, 30, 0),
    };
  }
  function R(t, a) {
    const o = new Map((t.productFamilies || []).map((e) => [e.id, e])),
      n = (a.assignments || [])
        .slice()
        .sort((e, d) => e.sortOrder - d.sortOrder),
      l = new Set(n.map((e) => e.productId)),
      c = new Set(),
      u = [];
    return (
      (a.productFamilyIds || []).forEach((e) => {
        const d = o.get(e);
        !d ||
          !d.enabled ||
          (d.members || [])
            .slice()
            .sort((s, r) => s.sortOrder - r.sortOrder)
            .forEach((s) => {
              l.has(s.productId) ||
                c.has(s.productId) ||
                (c.add(s.productId), u.push(s));
            });
      }),
      n.forEach((e) => {
        c.has(e.productId) || (c.add(e.productId), u.push(e));
      }),
      u.filter((e) => e.enabled !== !1).map((assignment) => {
        // A configured PF family narrows a broader inherited assignment.
        // Resolve exact Manager variant sets; never infer a mount from its name.
        const sets = new Map((t.assignmentSets || []).map((set) => [String(set.id), set]));
        const members = (a.configurationFamilyIds || []).flatMap((id) => {
          const family = o.get(id);
          return family && family.enabled !== false ? family.members || [] : [];
        });
        const member = members.find((item) => item.enabled !== false && item.productId === assignment.productId);
        if (!member) return assignment;
        const current = normaliseAssignment(assignment, sets), configured = normaliseAssignment(member, sets);
        if (!current || !configured || !configured.allowedVariantIds.length) return assignment;
        const allowed = current.allowedVariantIds.length ? current.allowedVariantIds.filter((id) => configured.allowedVariantIds.includes(id)) : configured.allowedVariantIds;
        return Object.assign({}, assignment, { variantSetId: '', allowedVariantIds: allowed,
          defaultVariantId: allowed.includes(current.defaultVariantId) ? current.defaultVariantId : allowed[0] || '' });
      }).filter((assignment) => !Array.isArray(assignment.allowedVariantIds) || assignment.allowedVariantIds.length)
    );
  }
  function normaliseAssignment(t, a) {
    let o = String(t.defaultVariantId || ""),
      n = (t.allowedVariantIds || []).map(String);
    const l = String(t.variantSetId || "");
    if (l) {
      const c = a.get(l);
      if (!c) return null;
      if (
        ((o = String(c.defaultVariantId || "")),
        (n = (c.allowedVariantIds || []).map(String)),
        !o || !n.includes(o))
      )
        return null;
    }
    return {
      productId: t.productId,
      role: t.role || "compatible",
      defaultVariantId: o,
      allowedVariantIds: n,
      sortOrder: Number(t.sortOrder || 0),
    };
  }
  function y(t) {
    return (t || []).filter((a) => a.active && a.visibility === "public");
  }
  function D(t) {
    const a = y(t).find(
        (n) => n.type === "youtube" || n.type === "installation",
      ),
      o =
        a &&
        String(a.url || "").match(
          /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([^?&/]+)/i,
        );
    return (o && o[1]) || "";
  }
  function M(t) {
    return String(t || "")
      .replace(/[-_]+/g, " ")
      .replace(/\b\w/g, (a) => a.toUpperCase());
  }
  let previewSource, previewConfiguration;
  function effectiveConfiguration(publication) {
    const node = document.getElementById("pesado-compatibility-preview-overrides");
    if (!node) return publication.configuration;
    if (previewSource === publication) return previewConfiguration;
    previewSource = publication;
    previewConfiguration = null;
    delete window.PesadoCompatibilityEffectiveConfiguration;
    delete window.PesadoCompatibilityPreview;
    try {
      const preview = JSON.parse(node.textContent || "{}");
      if (
        node.dataset.themeId !== "189357883699" ||
        preview.targetThemeId !== node.dataset.themeId ||
        preview.schemaVersion !== 1 ||
        preview.source?.version !== publication.version ||
        preview.source?.checksum !== publication.checksum ||
        !Array.isArray(preview.models)
      ) throw new Error("V1.2 review data does not match the published Manager source.");
      const pending = new Map(preview.models.map((entry) => [entry.brandId + ":" + entry.modelId, entry]));
      if (pending.size !== preview.models.length) throw new Error("Duplicate review model.");
      const allowedFields = new Set(["name", "aliases", "assignments", "configurationFamilyIds"]);
      const brands = publication.configuration.brands.map((brand) => {
        let changed = false;
        const models = brand.models.map((model) => {
          const key = brand.id + ":" + model.id, entry = pending.get(key);
          if (!entry) return model;
          if (!entry.fields || Object.keys(entry.fields).some((field) => !allowedFields.has(field)))
            throw new Error("Unsupported review model change.");
          pending.delete(key);
          changed = true;
          return Object.assign({}, model, entry.fields);
        });
        return changed ? Object.assign({}, brand, { models }) : brand;
      });
      if (pending.size) throw new Error("Review model is absent from the published source.");
      const images = new Map((preview.productImages || []).map((entry) => [entry.productId, entry]));
      const products = publication.configuration.products.map((product) => {
        const entry = images.get(product.id);
        if (!entry) return product;
        if (entry.asset?.kind !== "theme_asset" || !entry.variantId)
          throw new Error("Unsupported review image.");
        images.delete(product.id);
        const asset = product.id === "shopify-10449382703411" && node.dataset.gmImageUrl
          ? Object.assign({}, entry.asset, { cdnUrl: node.dataset.gmImageUrl }) : entry.asset;
        return Object.assign({}, product, {
          compatibilityImage: asset,
          variants: [...(product.variants || []).filter((variant) => String(variant.id) !== entry.variantId),
            { id: entry.variantId, compatibilityImage: asset }],
        });
      });
      if (images.size) throw new Error("Review image product is absent from the published source.");
      previewConfiguration = Object.assign({}, publication.configuration, { brands, products });
      window.PesadoCompatibilityEffectiveConfiguration = previewConfiguration;
      window.PesadoCompatibilityPreview = {
        targetThemeId: preview.targetThemeId,
        revision: preview.revision,
        checksum: preview.checksum,
        sourceVersion: publication.version,
        sourceChecksum: publication.checksum,
      };
    } catch (error) {
      console.error("[Pesado Compatibility] Invalid V1.2 review configuration.", error);
    }
    return previewConfiguration;
  }
  function T(t) {
    if (
      !t ||
      !t.configuration ||
      String(t.targetTheme && t.targetTheme.id) !== E
    )
      return null;
    const a = effectiveConfiguration(t);
    if (!a) return null;
    const
      assignmentSetById = new Map(
        (a.assignmentSets || []).map((e) => [String(e.id), e]),
      ),
      o = {},
      n = new Set();
    (a.products || []).forEach((e) => {
      if (e.recommendationEnabled === !1) return;
      n.add(e.id);
      const d = {};
      (e.variants || []).forEach((r) => {
        const m = f(r.compatibilityImage);
        m && (d[String(r.id)] = m);
      });
      const s = D(e.sources);
      o[e.id] = {
        id: e.id,
        cat: e.category,
        name: e.name,
        spec: e.spec,
        handle: e.handle,
        tokens: e.matchTokens || [],
        preferredVariantId: e.preferredVariantId || "",
        hiddenVariantIds: (e.hiddenVariantIds || []).map(String),
        compatibilityImageUrl: f(e.compatibilityImage),
        variantCompatibilityImages: d,
        sources: y(e.sources),
        video: !!s,
        videoId: s,
      };
    });
    const l = (a.brands || [])
        .filter((e) => e.enabled !== !1)
        .map((e) => {
          const d = (e.models || [])
              .filter((r) => r.enabled !== !1)
              .map((r) => {
                const h = R(a, r)
                    .filter((i) => n.has(i.productId))
                    .map((i) => normaliseAssignment(i, assignmentSetById))
                    .filter(Boolean),
                  S = {};
                return (
                  h.forEach((i) => {
                    S[i.productId] = {
                      role: i.role,
                      defaultVariantId: i.defaultVariantId,
                      allowedVariantIds: i.allowedVariantIds,
                      sortOrder: i.sortOrder,
                    };
                  }),
                  {
                    id: r.id,
                    name: r.name,
                    familyId: r.familyId || "",
                    aliases: r.aliases || [],
                    image: e.id === "gemilai" && r.image?.hasTransparency !== true ? "" : f(r.image),
                    products: h.map((i) => i.productId),
                    assignmentList: h,
                    assignments: S,
                    managerOrdered: !0,
                    sources: y(r.sources),
                    compatibilityNotice: r.publicComment || "",
                    heBasketFitNotice: r.heBasketFitNotice || "",
                  }
                );
              }),
            s = new Set();
          return (
            d.forEach((r) => r.products.forEach((m) => s.add(m))),
            {
              id: e.id,
              name: e.name,
              country: e.country,
              tier: e.tier,
              models: d,
              popular: !!e.popular,
              logo: f(e.logo),
              logoDisplay: P(e.logoDisplay),
              slug: e.slug,
              productCount: s.size,
            }
          );
        }),
      c = [],
      u = {};
    return (
      Object.values(o).forEach((e) => {
        !e.cat || u[e.cat] || (c.push(e.cat), (u[e.cat] = M(e.cat)));
      }),
      {
        products: o,
        brands: l,
        categoryLabels: u,
        categoryOrder: c,
        variantRecommendations: {},
        recommendationFamilies: {},
        universalRecommendations: a.universalRecommendations || [],
        installationVideos: {},
        preview: window.PesadoCompatibilityPreview || null,
        publication: {
          version: t.version,
          publishedAt: t.publishedAt,
          checksum: t.checksum,
          targetThemeId: String(t.targetTheme.id),
        },
      }
    );
  }
  function U() {
    return {
      products: {},
      brands: [],
      categoryLabels: {},
      categoryOrder: [],
      variantRecommendations: {},
      recommendationFamilies: {},
      universalRecommendations: [],
      installationVideos: {},
      managerUnavailable: !0,
    };
  }
  function C() {
    O();
    const t = T(window.PesadoCompatibilityManagerConfig);
    return ((window.PesadoCompatibilityData = t || U()), t && v(t), !!t);
  }
  let managerInitialisation;
  function initialiseManagerPublication() {
    if (managerInitialisation) return managerInitialisation;
    managerInitialisation = (async () => {
      if (C() || ((await loadManagerManifest()) && C())) {
        document.dispatchEvent(
          new CustomEvent("pesado:compatibility-data-ready"),
        );
        return !0;
      }
      v(window.PesadoCompatibilityData);
      return !1;
    })().finally(() => {
      managerInitialisation = void 0;
    });
    return managerInitialisation;
  }
  C() ||
    (window.addEventListener(
      "pesado:manager-publication-ready",
      initialiseManagerPublication,
      { once: !0 },
    ),
    initialiseManagerPublication());
})();
